import React from 'react';
import ModalHeader from '@/components/modal/ModalHeader.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import Modal from '@/components/modal/Modal.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import {
  tourOptionDefaultValues,
  TourOptionFormData,
  TourOptionInputForm,
  tourOptionSchema,
} from '@/features/dashboard/tourOptions/schemas/tourOptionSchema.ts';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import useCreateTourOption from '@/features/dashboard/tourOptions/hooks/useCreateTourOption.ts';
import { convertOptionFormToDto } from '@/features/dashboard/tourOptions/hooks/tourOptionConverter.ts';
import { tourOptionsConfigRoute } from '@/features/dashboard/tourOptions/routes/tourOptionsConfigRoute.ts';
import TourOptionsForm from '@/features/dashboard/tourOptions/components/TourOptionsForm.tsx';

const TourOptionAddModal = ({ onClose }: { onClose: () => void }) => {
  const { tourId } = tourOptionsConfigRoute.useParams();

  const { mutate: createTourOption, isPending: isCreating } =
    useCreateTourOption();

  const tourOptionsForm = useForm<
    TourOptionInputForm,
    unknown,
    TourOptionFormData
  >({
    resolver: debugZodResolver(tourOptionSchema),
    defaultValues: tourOptionDefaultValues,
  });

  const onSubmit = (data: TourOptionFormData) => {
    const dto = convertOptionFormToDto(tourId, data);
    createTourOption(dto, {
      onSuccess: (d) => {
        onClose();
      },
    });
  };

  return (
    <Modal onClose={onClose} isDirty={tourOptionsForm.formState.isDirty}>
      <ModalHeader title={'Dodaj dodatkową opcję'} onClose={onClose} />
      <FormProvider {...tourOptionsForm}>
        <form onSubmit={tourOptionsForm.handleSubmit((d) => onSubmit(d))}>
          <TourOptionsForm />

          <ModalFooter>
            <ActionButton tone="outline" size="sm" onClick={onClose}>
              Anuluj
            </ActionButton>
            <ActionButton
              tone="accent"
              size="sm"
              type="submit"
              isLoading={isCreating}
            >
              Dodaj
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default TourOptionAddModal;
